/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GenieWebhookPayload = {
    transactionId: string;
    state: GenieWebhookPayload.state;
    amount?: number;
    customerReference?: string;
    signature?: string;
};
export namespace GenieWebhookPayload {
    export enum state {
        INITIATED = 'INITIATED',
        CONFIRMED = 'CONFIRMED',
        FAILED = 'FAILED',
        CANCELLED = 'CANCELLED',
        REFUNDED = 'REFUNDED',
    }
}

